var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 280,
    height: 48,
    viewBox: "0 0 280 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape \xC2\xB7 cut corner",
    d: "M0 0H268L280 12V48H0V0Z",
    fill: "#B8EE3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClaim);
export default __webpack_public_path__ + "static/media/btn-claim.c7d3c44f36d682a8500efa579f751bc4.svg";
export { ForwardRef as ReactComponent };